import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { ModalAjudaAtivacaoKriptonitaComponent } from '../modal-ajuda-ativacao-kriptonita/modal-ajuda-ativacao-kriptonita.component';

@Component({
  selector: 'app-modal-crypto',
  templateUrl: './modal-crypto.component.html',
  styleUrls: ['./modal-crypto.component.css']
})
export class ModalCryptoComponent implements OnInit {
  ngOnInit() {}


  onYesClick(): void {
    this.dialogRef.close('download');
    this.document.location.href = this.data.action;
  }


  constructor(
    @Inject(DOCUMENT) private document: Document,
    public dialogRef: MatDialogRef<ModalCryptoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {}


 
 

 
}
